/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetNearbyTokenRequest} from '@cash-web/protos/squareup/franklin/app/nearby_token.pb'
import {GetNearbyTokenResponse} from '@cash-web/protos/squareup/franklin/app/nearby_token.pb'


export const getNearbyToken = (request: GetNearbyTokenRequest, options?: CashRequestOptions) => post<GetNearbyTokenRequest, GetNearbyTokenResponse>("/2.0/cash/get-nearby-token", request, {...options, rejectOnError: true })